import { useMediaQuery } from "react-responsive";

import { Box } from "@/components/layout/flexbox";
import { isXsQuery } from "@/components/layout/Media";
import { Clickable } from "@/components/pieces/interaction/Clickable";
import { StyledTag } from "@/components/pieces/StyledTag";
import { PopularTitlesQuery, usePopularTitlesQuery } from "@/graphql";
import { ensureNonNullArray } from "@/utils/array";
import { NonNullableArrayItem } from "@/utils/types";

type JobTitle = NonNullableArrayItem<PopularTitlesQuery["popularTitles"]>;

interface PopularTitlesProps {
  excludingTitles: JobTitle[];
  onSelect: (pt: JobTitle) => void;
}

export function PopularTitles({
  excludingTitles,
  onSelect,
}: PopularTitlesProps) {
  const isXs = useMediaQuery(isXsQuery);
  const { data } = usePopularTitlesQuery();

  const popularTitles = ensureNonNullArray(data?.popularTitles).filter(
    (pt) =>
      !excludingTitles.find((jt) => jt.normalizedTitle === pt.normalizedTitle),
  );

  return (
    <>
      {popularTitles.length ? (
        <Box mt={4}>
          <Box mb={2}>Popular Titles</Box>
          {popularTitles.map((pt) => {
            return (
              <Clickable key={pt.normalizedTitle} onClick={() => onSelect(pt)}>
                <StyledTag large={!isXs}>{pt.title}</StyledTag>
              </Clickable>
            );
          })}
        </Box>
      ) : null}
    </>
  );
}
